/*odometerOptions = { auto: false }; // Disables auto-initialization

$(function(){
   
  setTimeout(function(){

var startDate = new Date("2018-01-01");
var daysSince = Math.round((new Date()-startDate)/(1000*60*60*24));

  // For each odometer, initialize with the theme passed in:
  var odometer = new Odometer({ el: $('.odometer')[0], value: 	118004+(7 * daysSince), theme: 'default' });
  odometer.render();
  odometer.update(118004+(7 * daysSince));
  },1000);
});
*/

$(function(){
 
 
  $("#photos").owlCarousel({
 
      autoPlay: false,
 
      items : 4,
      itemsDesktop : [1199,3],
      itemsDesktopSmall : [991,4],
	  
	  navigation: true,
	  
	  navigationText : ["",""]
 
  });
  
  
   $("a[rel^='prettyPhoto']").prettyPhoto();
  
  
  $('.mybtnover').click(function(){
              $('.targetDiv').hide();
              $('#div'+$(this).attr('target')).show();
        });
  
  		 $('.part3nav1').click(function(){
              $('.givingback2atext').hide();
              $('.givingback2text').show();
        });
  
  		 $('.part3nav2').click(function(){
              $('.givingback2text').hide();
              $('.givingback2atext').show();
        })
  
         
    $(".mybtn").click(function(){
    $(".expand").removeClass( "expand").addClass("mybtn");
    $(this).removeClass( "mybtn" ).addClass('expand');
	});
 
});